module.exports = __webpack_public_path__ + "img/ping_web.dd1c74fc.png";